import React, { Component } from "react";
import { api } from "../../api/api";
import { FaDropbox } from "react-icons/fa6";

class ModalHistoricoStatusPedido extends Component {
    constructor(props) {
        super(props);
        this.state = this.initialState;

        this.openModal = (pedidoId) => {
            this.setState({ pedidoId }, () => this.carregarHistorico());
        };
    }

    initialState = {
        show: false,
        history: [],
        pedidoId: null,
        dataInicio: "",
        dataFim: "",
        tipo: "0",
        usuarioResponsavel: "",
    };


    onClose = () => this.setState(this.initialState);

    carregarHistorico = () => {
        const { pedidoId, dataInicio, dataFim, tipo } = this.state;

        const params = new URLSearchParams();
        if (dataInicio) params.append("dataInicio", dataInicio);
        if (dataFim) params.append("dataFim", dataFim);
        if (tipo !== "todos") params.append("tipo", tipo);

        api.get(`/api/Pedido/Historico/Status/${pedidoId}?${params.toString()}`, (res) => {
            this.setState({
                show: true,
                history: res.data,
            });
        });
    };

    handleChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
    };
    render() {
        const { history, show, dataInicio, dataFim, tipo } = this.state;

        return (
            <div
                className={`modal fade ${show ? "show d-block" : ""}`}
                tabIndex={-1}
                style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
            >
                <div className="modal-dialog modal-lg modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Histórico do Pedido</h5>
                            <button type="button" className="btn-close" onClick={this.onClose}></button>
                        </div>

                        <div className="modal-body">
                            {/* Filtros */}
                            <div className="row g-3 mb-4">
                                <div className="col-md-3">
                                    <label className="form-label">Data Inicial</label>
                                    <input
                                        type="date"
                                        name="dataInicio"
                                        className="form-control"
                                        value={dataInicio}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Data Final</label>
                                    <input
                                        type="date"
                                        name="dataFim"
                                        className="form-control"
                                        value={dataFim}
                                        onChange={this.handleChange}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Tipo</label>
                                    <select
                                        name="tipo"
                                        className="form-select"
                                        value={tipo}
                                        onChange={this.handleChange}
                                    >
                                        <option value="0">Todos</option>
                                        <option value="1">Status Pagamento</option>
                                        <option value="2">Status Pedido</option>
                                    </select>
                                </div>
                                <div className="col-md-3">
                                    <label className="form-label">Responsável</label>
                                    <select
                                        name="usuarioResponsavel"
                                        className="form-select"
                                        value={this.state.usuarioResponsavel}
                                        onChange={this.handleChange}
                                    >
                                        <option value="">Todos</option>
                                        {[...new Set(history.map(h => h.usuarioResponsavel))].map((u, i) => (
                                            <option key={i} value={u}>{u}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            {/* Timeline */}
                            <div className="position-relative ms-4">
                                {history.length === 0 && (
                                    <div className="d-flex align-items-center justify-content-center text-muted">
                                        <FaDropbox className="me-2" />
                                        Nenhum status foi encontrado...
                                    </div>
                                )}
                                {history
                                    .filter((x) => {
                                        const dataItem = new Date(x.dataAtualizacao).toISOString().split("T")[0];

                                        const dentroPeriodo =
                                            (!dataInicio || dataItem >= dataInicio) &&
                                            (!dataFim || dataItem <= dataFim);

                                        const tipoCond =
                                            tipo === "0" ||
                                            (tipo === "1" && x.tipo === "Status Pagamento") ||
                                            (tipo === "2" && x.tipo === "Status Pedido");

                                        const usuarioCond =
                                            !this.state.usuarioResponsavel || x.usuarioResponsavel === this.state.usuarioResponsavel;

                                        return dentroPeriodo && tipoCond && usuarioCond;
                                    })
                                    .map((item, index, filtered) => (
                                        <div
                                            key={index}
                                            className={`position-relative ps-4 mb-4 border-start ${index === filtered.length - 1 ? "border-success" : "border-primary"
                                                } border-2`}
                                        >
                                            <span
                                                className={`badge ${index === filtered.length - 1 ? "bg-success" : "bg-primary"
                                                    } position-absolute top-0 start-0 translate-middle rounded-pill`}
                                                style={{ width: "1rem", height: "1rem" }}
                                            ></span>

                                            <small className="text-muted">
                                                {new Date(item.dataAtualizacao).toLocaleString()}
                                            </small>

                                            <h6 className="mb-1">
                                                {item.statusAnterior} → {item.statusNovo}
                                            </h6>

                                            <p className="mb-0 text-muted">
                                                <strong>Responsável:</strong> {item.usuarioResponsavel}
                                                <br />
                                                <strong>Tipo:</strong> {item.tipo}
                                            </p>
                                        </div>
                                    ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ModalHistoricoStatusPedido;
